import axios from 'axios';

const rawBase = (process.env.REACT_APP_API_URL || 'https://app.nandofcomic3ds.com/').trim();
export const BaseUrl = rawBase.endsWith('/') ? rawBase : `${rawBase}/`;

/**
 * Axios instance used by the app.
 * - withCredentials: keeps cookies/session if API uses them
 */
export const http = axios.create({
  baseURL: BaseUrl,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
  timeout: 300000,
});
